<template>
  <div>
    <div :class="[controlClass, { 'is-invalid': isInvalid() }]">
      <slot />
    </div>
    <small
      :class="[
        { 'form-text': !isInvalid() },
        { 'text-pf-muted': !isInvalid() },
        { 'invalid-feedback': isInvalid() }
      ]"
    >
      <span v-if="!isInvalid()">{{ hint }}</span>
      <span v-else>{{ errorMessages[0] }}</span>
    </small>
  </div>
</template>

<script>
export default {
  props: {
    hint: {
      type: String,
      default: ""
    },
    errorMessages: {
      type: Array,
      default: function () {
        return [];
      }
    },
    controlClass: {
      type: String,
      default: ""
    }
  },
  methods: {
    isInvalid() {
      return Boolean(this.errorMessages.length);
    }
  }
};
</script>
